// @ts-nocheck

import { request } from '../../../context';
import type { ApiOptions } from '../../../context';
import type {
    GetSmartTagsModelGenerateQuery,
    BaseResponseInspectionSmartTagGenerateResponse,
    PostSmartTagsModelGenerateBody,
    BaseResponseVoid,
    PutSmartTagsModelGenerateBody,
    DeleteSmartTagsModelGenerateQuery,
} from '../../../types';

/**
 * 获取大模型生成标签批处理定时任务配置
 *
 * @export
 * @tags smart-tag-controller
 * @link [GET] /smartTags/model/generate
 */
export function getSmartTagsModelGenerate(
    options: ApiOptions<never, GetSmartTagsModelGenerateQuery> & {
        params: GetSmartTagsModelGenerateQuery;
    }
): Promise<BaseResponseInspectionSmartTagGenerateResponse> {
    return request<never, never, GetSmartTagsModelGenerateQuery>('/smartTags/model/generate', {
        ...options,
        method: 'get',
        __$requestCalleeName: 'getSmartTagsModelGenerate',
    });
}

/**
 * 大模型生成标签批处理任务
 *
 * @export
 * @tags smart-tag-controller
 * @link [POST] /smartTags/model/generate
 */
export function postSmartTagsModelGenerate(
    data: PostSmartTagsModelGenerateBody
): Promise<BaseResponseVoid>;
export function postSmartTagsModelGenerate(
    data: PostSmartTagsModelGenerateBody,
    options: ApiOptions<never, never>
): Promise<BaseResponseVoid>;
export function postSmartTagsModelGenerate(
    data: PostSmartTagsModelGenerateBody,
    options?: ApiOptions<never, never>
): Promise<BaseResponseVoid> {
    return request<PostSmartTagsModelGenerateBody, never, never>('/smartTags/model/generate', {
        ...options,
        data,
        method: 'post',
        __$requestCalleeName: 'postSmartTagsModelGenerate',
    });
}

/**
 * 修改大模型生成标签批处理定时任务配置
 *
 * @export
 * @tags smart-tag-controller
 * @link [PUT] /smartTags/model/generate
 */
export function putSmartTagsModelGenerate(
    data: PutSmartTagsModelGenerateBody
): Promise<BaseResponseVoid>;
export function putSmartTagsModelGenerate(
    data: PutSmartTagsModelGenerateBody,
    options: ApiOptions<never, never>
): Promise<BaseResponseVoid>;
export function putSmartTagsModelGenerate(
    data: PutSmartTagsModelGenerateBody,
    options?: ApiOptions<never, never>
): Promise<BaseResponseVoid> {
    return request<PutSmartTagsModelGenerateBody, never, never>('/smartTags/model/generate', {
        ...options,
        data,
        method: 'put',
        __$requestCalleeName: 'putSmartTagsModelGenerate',
    });
}

/**
 * 删除大模型生成标签批处理定时任务配置
 *
 * @export
 * @tags smart-tag-controller
 * @link [DELETE] /smartTags/model/generate
 */
export function deleteSmartTagsModelGenerate(
    options: ApiOptions<never, DeleteSmartTagsModelGenerateQuery> & {
        params: DeleteSmartTagsModelGenerateQuery;
    }
): Promise<BaseResponseVoid> {
    return request<never, never, DeleteSmartTagsModelGenerateQuery>('/smartTags/model/generate', {
        ...options,
        method: 'delete',
        __$requestCalleeName: 'deleteSmartTagsModelGenerate',
    });
}

export const meta = [
    { tags: ['smart-tag-controller'], path: '/smartTags/model/generate', method: 'get' },
    { tags: ['smart-tag-controller'], path: '/smartTags/model/generate', method: 'post' },
    { tags: ['smart-tag-controller'], path: '/smartTags/model/generate', method: 'put' },
    { tags: ['smart-tag-controller'], path: '/smartTags/model/generate', method: 'delete' },
];
